/** A numeric category breakdown can be visualised without knowing the question name. */
export interface InsightCategoryChart {
  data: { label: string; value: number }[];
  valueSuffix: string;
  reportedCount: number;
}

export function buildInsightCategoryChart(schema: any, answer: unknown): InsightCategoryChart | null {
  if (schema?.display_type !== 'labelled_pills' || !Array.isArray(answer) || answer.length < 2) return null;

  const labelKey = schema.text_property_name;
  const valueKey = schema.on_hover_property_name;
  if (!labelKey || !valueKey) return null;

  const isPercentage = /(?:percentage|percent|share|proportion|fraction)/i.test(valueKey);
  if (!isPercentage) return null;

  const data: { label: string; value: number }[] = [];
  for (const item of answer) {
    const label = item?.[labelKey];
    const raw = item?.[valueKey];
    if (typeof label !== 'string' || !label.trim() || raw === null || raw === undefined || raw === '') return null;
    const value = Number(raw);
    if (!Number.isFinite(value) || value < 0 || value > 100) return null;
    if (value > 0) data.push({ label: label.trim(), value });
  }
  if (data.length < 2) return null;

  const sum = data.reduce((total, item) => total + item.value, 0);
  // A donut implies mutually exclusive slices. If percentages exceed 100,
  // retain the source list rather than misrepresenting overlapping categories.
  if (sum > 100.001) return null;
  const reportedCount = data.length;
  if (sum < 99.999) data.push({ label: 'Unspecified', value: Number((100 - sum).toFixed(2)) });

  return { data, valueSuffix: '%', reportedCount };
}
